import { h } from 'preact';
import { Text } from 'preact-i18n';
import style from './style';

const ErrorMessage = ({ displayMode }) => (<div class={style.errorMsg}>
	{!displayMode &&
		<p><Text id="error-line-1">Oops, something went wrong.</Text></p>
	}

	<p><Text id="error-line-2">Please check back shortly.</Text></p>

</div>);
export default ErrorMessage;
